import { logoutSuccess } from 'features/auth/redux/actions';
import { REMOVE_MESSAGE, ADD_ERROR_MESSAGE, ADD_SUCCESS_MESSAGE } from 'features/message/redux/types';

export const addErrorMessage = (errorMessage: string) => ({
  type: ADD_ERROR_MESSAGE,
  payload: errorMessage,
});

export const addSuccessMessage = (successMessage: string) => ({
  type: ADD_SUCCESS_MESSAGE,
  payload: successMessage,
});

export const removeMessage = (timestamp: number) => ({
  type: REMOVE_MESSAGE,
  payload: timestamp,
});

export type MessageActionsType = ReturnType<
  typeof logoutSuccess | typeof addErrorMessage | typeof addSuccessMessage | typeof removeMessage
>;
